var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCultist3Black(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    width: "0px",
    height: "0px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.885042, 0, 0, 0.885042, 36.407448, 30.746794)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 40
    },
    d: "M 297.575 146.438 L 297.529 146.505 L 297.484 146.438 Z M 297.529 146.505 L 524.412 486.831 C 467.681 430.098 127.287 430.098 70.555 486.831 Z M 298.256 374.905 C 314.223 327 314.223 312.018 298.249 259.435 C 283.586 312.018 283.586 328.773 298.256 374.905 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 20
    },
    d: "M 378.802 227.474 C 375.891 227.834 382.689 142.349 438.608 162.764 C 488.939 181.138 513.138 127.118 511.901 113.892 C 510.664 100.667 497.999 88.625 483.995 90.516 C 530.194 81.241 533.921 107.745 528.122 133.799 C 521.803 162.188 512.368 170.138 497.999 180.803 C 483.63 191.467 463.166 185.937 421.839 185.366 C 408.551 187.036 382.911 206.479 378.802 227.474 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 20
    },
    d: "M 446.706 341.63 C 438.129 329.892 467.953 306.403 493.542 298.533 C 530.611 287.132 530.045 322.422 551.337 328.282 C 571.703 331.054 602.347 297.301 598.399 292.466 C 601.321 290.48 607.465 319.625 561.236 351.041 C 540.215 363.856 523.808 334.337 507.999 327.481 C 488.017 318.816 451.32 328.262 446.706 341.63 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 20
    },
    d: "M 295.133 120.187 C 288.538 116.007 280.09 97.302 286.533 69.314 C 296.466 46.68 297.597 45.819 296.48 15.065 C 306.054 27.192 317.659 72.861 306.951 87.208 C 296.243 101.557 296.48 104.445 295.133 120.187 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 20
    },
    d: "M 356.899 433.915 C 320.752 470.444 360.147 516.154 394.068 511.573 C 462.764 502.295 406.233 563.734 378.242 576.354 C 445.203 576.354 472.483 546.205 451.39 503.566 C 425.108 450.438 345.724 529.489 356.899 433.915 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 20
    },
    d: "M 304.679 433.487 C 301.258 432.301 259.516 490.275 279.266 512.146 C 320.752 558.09 266.535 603.979 273.155 599.726 C 279.775 595.473 318.971 567.332 320.752 534.624 C 318.971 505.184 281.432 507.422 304.679 433.487 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 40
    },
    d: "M 170.985 269.963 C 170.985 339.21 209.095 250.921 298.02 250.921 C 298.258 250.921 298.495 250.921 298.732 250.921 C 282.643 308.725 282.509 327.755 298.339 377.955 C 298.234 377.955 298.127 377.955 298.02 377.955 C 232.509 377.955 219.703 359.299 183.688 339.845 C 121.208 306.093 170.985 269.693 170.985 269.693 Z M 425.055 269.975 C 453.069 294.818 445.934 319.079 409.684 339.845 C 376.818 358.67 363.723 377.673 299.459 377.953 C 316.707 325.834 316.57 308.736 299.037 250.923 C 399.818 251.472 425.055 333.421 425.055 269.975 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 20
    },
    d: "M 298.674 246.026 C 312.752 292.37 312.752 305.574 298.68 347.795 C 285.75 307.137 285.75 292.37 298.674 246.026 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 20
    },
    d: "M 229.693 59.448 C 236.131 59.019 245.379 89.554 242.197 108.042 C 228.062 147.358 232.002 154.072 250.143 162.979 C 227.756 143.259 251.09 131.257 259.027 110.205 C 266.964 89.153 229.66 58.808 229.693 59.448 Z",
    transform: "matrix(-1, 0, 0, -1, 489.828064, 222.417046)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 20
    },
    d: "M 142.559 576.354 C 106.412 539.825 145.807 494.116 179.728 498.697 C 248.424 507.975 220.435 428.702 169.167 451.212 C 209.467 403.92 258.143 464.064 237.05 506.703 C 210.768 559.832 131.384 480.78 142.559 576.354 Z",
    transform: "matrix(-1, 0, 0, -1, 370.328186, 1010.270142)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 20
    },
    d: "M 68.28 88.626 C 65.369 88.267 72.167 173.751 128.086 153.337 C 178.417 134.963 202.616 188.982 201.379 202.208 C 200.142 215.434 196.107 221.455 173.473 225.585 C 219.672 234.86 223.399 208.356 217.6 182.302 C 211.281 153.912 201.846 145.963 187.477 135.298 C 173.108 124.633 152.644 130.164 111.317 130.734 C 98.029 129.065 72.389 109.621 68.28 88.626 Z",
    transform: "matrix(-1, 0, 0, -1, 287.412918, 316.100998)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 20
    },
    d: "M 1.502 300.942 C -7.075 312.68 22.749 336.169 48.338 344.039 C 85.407 355.44 84.841 320.15 106.133 314.29 C 126.499 311.518 157.143 345.271 153.195 350.106 C 156.117 352.092 162.261 322.947 116.032 291.531 C 95.011 278.716 78.604 308.235 62.795 315.091 C 42.813 323.756 6.116 314.31 1.502 300.942 Z",
    transform: "matrix(-1, 0, 0, -1, 155.194432, 638.546173)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 20
    },
    d: "M 332.799 163.969 C 339.237 164.397 348.485 133.863 345.303 115.375 C 331.168 76.059 335.108 69.345 353.249 60.438 C 330.862 80.158 354.196 92.16 362.133 113.212 C 370.07 134.264 332.766 164.609 332.799 163.969 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCultist3Black);
export default __webpack_public_path__ + "static/media/Cultist3-Black.d30c3ea272985d32c38b5bb35b38e21e.svg";
export { ForwardRef as ReactComponent };